import { Settings } from '@/models';

type MapsNavigationOptions = {
  address: Settings['property']['address'];
};

export const useMapsNavigation = ({ address }: MapsNavigationOptions) => {
  if (!address) {
    return { openMaps: () => {} };
  }

  const { latitude, longitude } = address;

  const openMaps = () => {
    const formattedAddress = encodeURIComponent(
      `${address.address1}${address.address2 ? `, ${address.address2}` : ''}, ${address.city}, ${address.state}, ${address.country} ${address.zip}`,
    );

    const isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;

    const isAndroid = /Android/.test(navigator.userAgent);

    if (latitude && longitude) {
      if (isIOS) {
        window.open(
          `maps://?q=${formattedAddress}&ll=${latitude},${longitude}`,
          '_blank',
        );
      } else if (isAndroid) {
        window.open(
          `geo:${latitude},${longitude}?q=${formattedAddress}`,
          '_blank',
        );
      } else {
        window.open(
          `https://www.google.com/maps/search/?api=1&query=${formattedAddress}&ll=${latitude},${longitude}`,
          '_blank',
        );
      }
    } else {
      // address string fallback
      if (isIOS) {
        window.open(`maps://?q=${formattedAddress}`, '_blank');
      } else if (isAndroid) {
        window.open(`geo:0,0?q=${formattedAddress}`, '_blank');
      } else {
        window.open(
          `https://www.google.com/maps/search/?api=1&query=${formattedAddress}`,
          '_blank',
        );
      }
    }
  };

  return { openMaps };
};
